import type { SVGProps } from 'react'
import * as React from 'react'

const credit = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_24_1971)">
      <path
        d="M13.9996 2H5.99991C5.4695 2 4.96082 2.21071 4.58576 2.58579C4.2107 2.96086 4 3.46957 4 4V20C4 20.5304 4.2107 21.0391 4.58576 21.4142C4.96082 21.7893 5.4695 22 5.99991 22H17.9994C18.5298 22 19.0385 21.7893 19.4135 21.4142C19.7886 21.0391 19.9993 20.5304 19.9993 20V8L13.9996 2Z"
        stroke="#1B1C1F"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 2V8H20" stroke="#1B1C1F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.0595 18.15C12.8862 18.15 13.5795 17.945 14.1395 17.535C14.7029 17.125 15.0995 16.57 15.3295 15.87L13.9595 15.49C13.8262 15.9233 13.6012 16.2617 13.2845 16.505C12.9679 16.7483 12.5595 16.87 12.0595 16.87C11.3762 16.87 10.8612 16.6467 10.5145 16.2C10.1712 15.75 9.99953 15.15 9.99953 14.4C9.99953 13.65 10.1712 13.0517 10.5145 12.605C10.8612 12.155 11.3762 11.93 12.0595 11.93C12.5595 11.93 12.9679 12.0517 13.2845 12.295C13.6012 12.535 13.8262 12.8733 13.9595 13.31L15.3295 12.93C15.0995 12.23 14.7029 11.675 14.1395 11.265C13.5795 10.855 12.8862 10.65 12.0595 10.65C11.3395 10.65 10.7179 10.8067 10.1945 11.12C9.67453 11.4333 9.27286 11.8717 8.98953 12.435C8.70953 12.9983 8.56953 13.6533 8.56953 14.4C8.56953 15.1467 8.70953 15.8017 8.98953 16.365C9.27286 16.9283 9.67453 17.3667 10.1945 17.68C10.7179 17.9933 11.3395 18.15 12.0595 18.15Z"
        fill="#1B1C1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_24_1971">
        <rect width={23.999} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default credit
